import { DefaultButton, PrimaryButton, Stack } from "@fluentui/react";
import { Link, useNavigate } from "react-router-dom";

import { MembershipValidationResponse } from "./interface";
import { ButtonContainer, Title, Wrapper } from "./styles";

interface IMembershipValidationModal {
  membershipValidationData: MembershipValidationResponse;
  showTermModal: (status: boolean) => void;
}

export function MembershipValidationModal({
  membershipValidationData,
  showTermModal
}: IMembershipValidationModal): JSX.Element {
  const navigate = useNavigate();

  const finishBackofficeTerm = (
    <Stack>
      <Title>Não foi possível confirmar contrato</Title>

      <p>
        Para confirmar o contrato, é necessário finalizar a associação inciada
        por meio do Portal do Cooperado.
      </p>

      <ButtonContainer>
        <DefaultButton id="button-cancel" onClick={() => showTermModal(false)}>
          Cancelar
        </DefaultButton>
      </ButtonContainer>
    </Stack>
  );

  const term = membershipValidationData?.term;
  const finishLibertasTerm = (
    <Stack>
      <Title>Ficha de Matrícula em andamento</Title>

      <p>Para seguir no contrato é necessário estar associado</p>

      <Link to={`/terms/${term?.id}`}>
        <p>
          Ficha de Matrícula <strong>#{term?.id}</strong>
        </p>
      </Link>

      <ButtonContainer>
        <DefaultButton id="button-cancel" onClick={() => showTermModal(false)}>
          Cancelar
        </DefaultButton>

        <PrimaryButton
          id="button-cancel"
          onClick={() => navigate(`/terms/${term?.id}`)}
        >
          Ir para ficha de matrícula
        </PrimaryButton>
      </ButtonContainer>
    </Stack>
  );

  return (
    <Wrapper>
      {membershipValidationData.hasInitiatedBackofficeTerm
        ? finishBackofficeTerm
        : finishLibertasTerm}
    </Wrapper>
  );
}
